import { render, staticRenderFns } from "./LeaveCodeList.vue?vue&type=template&id=39fd8b7a"
import script from "./LeaveCodeList.ts?vue&type=script&lang=ts&external"
export * from "./LeaveCodeList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports